import * as React from 'react'
import { FieldLabel, FieldValue, Stack } from '@lightspeed/design-system-react'
import { ServiceItem } from '../../../../../../models/sale.constants'
import { ServiceItemBadge } from './ServiceItemBadge'
interface Props {
  serviceItem: ServiceItem
}

export const SelectedItemView: React.FC<Props> = ({ serviceItem }) => {
  return (
    <Stack space={2} className="vd-pt5">
      <FieldLabel label="Customer’s item" />
      <FieldValue data-testid="selected-item-badge">
        <ServiceItemBadge
          header={serviceItem.itemName}
          description={serviceItem.serialNumber}
        />
      </FieldValue>
    </Stack>
  )
}
